export default function initFloatingPhone() {
    // ==========================================================
    // FLOATING PHONE
    // ==========================================================

    const floatingPhone = document.querySelector(".floating-phone");

    const phoneToggle = document.querySelector(".floating-phone__toggle");

    if (floatingPhone && phoneToggle) {
        let closeTimeout = null;

        const closePhone = () => {
            floatingPhone.classList.remove("is-open");

            phoneToggle.setAttribute("aria-expanded", "false");

            if (closeTimeout) {
                clearTimeout(closeTimeout);
                closeTimeout = null;
            }
        };

        const openPhone = () => {
            floatingPhone.classList.add("is-open");

            phoneToggle.setAttribute("aria-expanded", "true");

            if (closeTimeout) {
                clearTimeout(closeTimeout);
            }

            closeTimeout = setTimeout(() => {
                closePhone();
            }, 2000);
        };

        phoneToggle.addEventListener("click", () => {
            const isOpen = floatingPhone.classList.contains("is-open");

            if (isOpen) {
                closePhone();
                return;
            }

            openPhone();
        });
    }
}
